// extracted by mini-css-extract-plugin
export var assigneeBadge = "_jr-0";
export var assigneeDetails = "_jr-1";
export var assigneeInfo = "_jr-2";
export var dropdownContainer = "_jr-4";
export var dropdownImage = "_jr-5";
export var editAssigneeInfo = "_jr-3";
export var editAssigneeModalContainer = "_jr-6";
export var hidden = "_jr-8";
export var input = "_jr-7";